(function() {
$(document).on("ajax:success", "form#new_user", function(e, data, status, xhr) {
  if (data.success) {
    return window.location = data.redirect_to;
  } else {
    return $("form#new_user #error_message").show();
  }
});

}).call(window);
